import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  private passOneSecond: Observable<number> = interval(1000);
  public timer: Subscription;
  private currentTime: number;
  public currentClockTime: BehaviorSubject<{ minutes: string, seconds: string }> = new BehaviorSubject({minutes: '0', seconds: '00'});

  private paused = false;
  public timeOutNotifier: BehaviorSubject<boolean>;

  private initialTimerTime = 60;
  public passedQuestions = 0;

  constructor(private cookieService: CookieService) { }

  public SetNewGameValues(): void {
    this.initialTimerTime = 60;
    this.passedQuestions = 0;
    this.currentTime = 60;
    this.CalculateMinutesAndSeconds();
    this.timeOutNotifier = new BehaviorSubject(false);
    if (this.timer) { this.timer.unsubscribe(); }
    this.SaveCurrentValues();
  }

  public StartTimer(): void {

    if (!this.currentTime || this.currentTime === 0) {
      this.CalculateNewCountdownTime();
    }

    this.timer = this.passOneSecond.subscribe(value => {
      if (this.currentTime > 0) {
        this.IncrementClock();
      } else {
        this.TimeOut();
      }
    });

    this.CalculateMinutesAndSeconds();
    this.paused = false;
    if (!this.timeOutNotifier){
      this.timeOutNotifier = new BehaviorSubject(false);
    }
    else {
      this.timeOutNotifier.next(false);
    }

  }

  private CalculateNewCountdownTime(): void {
    const changeValue = 5 - Math.floor(this.passedQuestions / 4);
    this.initialTimerTime = this.initialTimerTime - (changeValue > 0 ? changeValue : 1);
    this.initialTimerTime = this.initialTimerTime >= 2 ? this.initialTimerTime : 2;
    this.currentTime = this.initialTimerTime;
    this.SaveCurrentValues();
  }

  private CalculateMinutesAndSeconds(): void {
    const seconds = this.currentTime % 60;
    const newClockTime = {
      minutes: (Math.floor(this.currentTime / 60)).toString(),
      seconds: (seconds < 10 ? '0' + seconds : seconds).toString()
    };
    this.currentClockTime.next(newClockTime);
  }

  private IncrementClock(): void {
    if (this.paused) { return; }
    this.currentTime--;

    if (this.currentTime <= 0) {
      this.TimeOut();
    }

    this.CalculateMinutesAndSeconds();
    this.SaveCurrentValues();
  }

  public StopTheTimer(pauseOnly: boolean = false): void {
    this.timer.unsubscribe();
    if (!pauseOnly) {
      this.currentTime = 0;
      this.SaveCurrentValues();
    }
  }

  private TimeOut(): void {
    this.timeOutNotifier.next(true);
  }

  public CheckRelevantCookieData(): void {

    if (!!this.cookieService.GetCookieValue('currentTime')) {
      this.currentTime =  parseInt(this.cookieService.GetCookieValue('currentTime'), 10);
      this.CalculateMinutesAndSeconds();
    }
    if (!!this.cookieService.GetCookieValue('initialTimerTime')) {
      this.initialTimerTime =  parseInt(this.cookieService.GetCookieValue('initialTimerTime'), 10);
    }
    if (!!this.cookieService.GetCookieValue('passedQuestions')) {
      this.passedQuestions =  parseInt(this.cookieService.GetCookieValue('passedQuestions'), 10);
    }

  }

  public IncrementQuestionCount(): void {
    this.passedQuestions++;
    this.SaveCurrentValues();
  }

  public SaveCurrentValues(): void {
    this.cookieService.SetCookieValue('currentTime', this.currentTime);
    this.cookieService.SetCookieValue('initialTimerTime', this.initialTimerTime);
    this.cookieService.SetCookieValue('passedQuestions', this.passedQuestions);
  }

}
